import React from "react";
import { useFormContext } from "react-hook-form";

import css from "./ModalSelectDeliveryInterval.module.css";
import { useTranslation } from "react-i18next";

const timeSlots = [
  "07:00 - 08:00",
  "08:00 - 09:00",
  "09:00 - 10:00",
  "10:00 - 11:00",
  "20:00 - 21:00",
  "21:00 - 22:00",
  "22:00 - 23:00",
  "23:00 - 00:00",
  "07:00 - 09:00",
  "08:00 - 10:00",
  "09:00 - 11:00",
  "20:00 - 22:00",
  "21:00 - 23:00",
  "22:00 - 00:00",
];

const ModalSelectDeliveryInterval = () => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className={css.wrap}>
      <label htmlFor="deliveryInterval">{t("delivery-interval")}</label>
      <select
        id="deliveryInterval"
        name="deliveryInterval"
        {...register("deliveryInterval")}
      >
        <option value=""></option>
        {timeSlots.map((obj) => (
          <option key={obj} value={obj}>
            {obj}
          </option>
        ))}
      </select>

      {errors.deliveryInterval && (
        <p className={css.error}>{errors.deliveryInterval.message}</p>
      )}
    </div>
  );
};

export { ModalSelectDeliveryInterval };
